import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

const { NOT_AVAILABLE } = API_ENDPOINTS;

export const notAvailableApi = {
  getDemandList: () => axiosInstance.get(NOT_AVAILABLE.LIST),
  restockPart: (data) => axiosInstance.post(NOT_AVAILABLE.RESTOCK, data),
  getRestocks: () => axiosInstance.get(NOT_AVAILABLE.RESTOCKS),
  // Correct a restock price from the office side. Mirrors the supervisor's
  // PATCH — either side can type a wrong price, so either must be able to fix it.
  updateRestock: (id, data) => axiosInstance.patch(NOT_AVAILABLE.RESTOCK_DETAIL(id), data),
};
